export default {
  CUT: "CUT",
  COPY: "COPY",
  PASTE: "PASTE"
};
